import {
  ATENCIONSINTURNO_LOADING,
  ATENCIONSINTURNO_SUCCESS,
  ATENCIONSINTURNO_ERROR,
} from "../../ActionTypes";

import axiosLogin from "../../../../global/helpers/axiosLogin";

export const wsGetCentros = () => (dispatch) => {
  dispatch({
    type: ATENCIONSINTURNO_LOADING,
  });

 axiosLogin().then(respuesta => {
  respuesta
  .get(`/shared/centros`)
  .then((res) => {
    dispatch({
      type: ATENCIONSINTURNO_SUCCESS,
      payload: res.data,
    });
  })
  .catch((err) => {
    let error = {
      detail: err.response
        ? err.response.data
        : "Error al contactar el server.",
    };

    dispatch({
      type: ATENCIONSINTURNO_ERROR,
      payload: error,
    });
  });
 } )
};
// export const wsGetCentros = () => (dispatch) => {
//   dispatch({
//     type: ATENCIONSINTURNO_LOADING,
//   });

//  axiosInstance().then(respuesta => {
//   respuesta
//   .get(`/texto/GetCentros`)
//   .then((res) => {
//     dispatch({
//       type: ATENCIONSINTURNO_SUCCESS,
//       payload: res.data,
//     });
//   })
//   .catch((err) => {
//     let error = {
//       detail: err.response
//         ? err.response.data
//         : "Error al contactar el server.",
//     };

//     dispatch({
//       type: ATENCIONSINTURNO_ERROR,
//       payload: error,
//     });
//   });
//  } )
// };
